export const AUTH_TOKEN = "auth-token";
export const PLANS_PAGE_SLUG = "/plans";
export const DRAWER_WIDTH = 240;
export const APPLE_STORE_LINK =
  "https://apps.apple.com/us/app/connect-self-guided-therapy/id1558756085";
export const GOOGLE_PLAY_LINK =
  "https://play.google.com/store/apps/details?id=com.lasting.connect";

export default { AUTH_TOKEN, DRAWER_WIDTH, APPLE_STORE_LINK, GOOGLE_PLAY_LINK };
